<template lang="html">
  <div class="conversations-empty">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ConversationsEmpty',
  props: {
    hasConversations: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css" scoped="true">
.conversations-empty {
  box-sizing: border-box;
  height: calc(100% - 48px);
  justify-content: center;
  margin: 16px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;

  border-radius: 16px;
  color: var(--gray-600);
}
</style>
